import { CORE_AXIOS, type Http } from "@/core"
import { container } from "tsyringe"

// 领取优惠券
export const getCouponProductsList = async (couponId: number | string) => {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get(`/v1/api/activity/coupons/${couponId}/products`)
}
